import { render } from "./commonScroll.vue?vue&type=template&id=fe5a5e0e"
import script from "./commonScroll.vue?vue&type=script&lang=js"
export * from "./commonScroll.vue?vue&type=script&lang=js"

import "./commonScroll.vue?vue&type=style&index=0&id=fe5a5e0e&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__